interface IDetailActionsProps {
  onAccept?: () => void;
  onReject?: () => void;
  hasCounterProposal?: boolean;
}

const DetailActions = (props: IDetailActionsProps) => {
  return (
    <div className="flex flex-row justify-between items-start mt-10">
      <div className="flex flex-row items-start gap-2 flex-1">
        <div className="flex bg-[#e7eff5] dark:bg-sky-950/40 rounded-md flex-row items-center justify-start border border-[#4e7b99] dark:border-sky-800 p-2 flex-1">
          <img src="/assets/images/info.svg" alt="Info" className="w-8 h-8 mt-1 mr-2" />
          <div className="text-size-12 text-gray-600 dark:text-neutral-300">
            Ao clicar em Aceitar, o serviço será autorizado e o veículo seguirá para manutenção.
          </div>
        </div>
      </div>

      <div className="flex flex-row gap-4">
        {
          props.hasCounterProposal ? (
            <>
              <button
                type="button"
                className="ml-5 w-[250px] bg-teal-500 text-white rounded-md hover:bg-teal-600 px-6 py-2 text-size-15 font-bold"
                onClick={props.onReject}
              >
                Enviar contraproposta
              </button>
            </>
          ) : (
            <>
              {props.onReject && (
                <button
                  type="button"
                  className="ml-6 w-[250px] border border-red-500 dark:border-red-700 text-red-500 dark:text-red-400 bg-white dark:bg-neutral-900 rounded-md hover:bg-red-50 dark:hover:bg-red-900/20 px-6 py-2 text-size-15 font-bold"
                  onClick={props.onReject}
                >
                  Recusar
                </button>
              )}
              {props.onAccept && (
                <button
                  type="button"
                  className="ml-5 w-[250px] bg-teal-500 text-white rounded-md hover:bg-teal-600 px-6 py-2 text-size-15 font-bold"
                  onClick={props.onAccept}
                >
                  Aceitar
                </button>
              )}
            </>
          )
        }
      </div>
    </div>
  );
};

export default DetailActions;
